import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import React from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { useSelector } from 'react-redux';

import { RewardChipPng, WalletBaseSvg, WalletPlusSvg } from '../../../assets/event';
import { RootState } from '../../../store';
import { TouchableOpacity } from '../../Components/common/Touchable';
import { RootStackParamList } from '../../navigator';

type Nav = NativeStackNavigationProp<RootStackParamList>;

// Figma "Wallet" (3324:18887) on the event Top Bar (3324:18867): a 161x43 plate carrying the
// chip, the balance and the buy button. The plate art bleeds past the row - the export is
// 181x63.5 for a 161x43 box - so it is drawn at its own size behind the row, offset by the bleed.
const WALLET_WIDTH = 161;
const WALLET_HEIGHT = 43;
const BASE_WIDTH = 181.049;
const BASE_HEIGHT = 63.483;
const BASE_LEFT = -(BASE_WIDTH - WALLET_WIDTH) / 2;
const BASE_TOP = -(BASE_HEIGHT - WALLET_HEIGHT) / 2;
const PLUS_SIZE = 23.72;
// The chip art sits low in its 32x43 slot, 9.17 from the top - not centred on the row.
const CHIP = { width: 32.43, height: 33.05, top: 9.17, slotWidth: 32 };

const formatChips = (chips: number) => new Intl.NumberFormat('de-DE').format(chips);

/**
 * The redesigned balance pill. Profile still paints its own older pill on the avatar header;
 * this is the version the event brief draws, built from that file's exported plate art.
 */
export const HeaderWallet = () => {
	const { navigate } = useNavigation<Nav>();
	const chips = useSelector((state: RootState) => state.auth.user?.chips) ?? 0;
	const openShop = () => navigate('BuyPackages', { activeTab: 'chips' });

	return (
		<View style={styles.wallet}>
			<View pointerEvents='none' style={styles.base}>
				<WalletBaseSvg width={BASE_WIDTH} height={BASE_HEIGHT} />
			</View>

			<TouchableOpacity activeOpacity={0.9} onPress={openShop} style={styles.row}>
				<View style={styles.chipSlot}>
					<Image source={RewardChipPng} style={styles.chip} resizeMode='contain' />
				</View>
				<Text numberOfLines={1} style={styles.balance}>
					{formatChips(chips)}
				</Text>
				<WalletPlusSvg width={PLUS_SIZE} height={PLUS_SIZE} />
			</TouchableOpacity>
		</View>
	);
};

const styles = StyleSheet.create({
	wallet: {
		width: WALLET_WIDTH,
		height: WALLET_HEIGHT,
	},
	base: {
		position: 'absolute',
		left: BASE_LEFT,
		top: BASE_TOP,
		width: BASE_WIDTH,
		height: BASE_HEIGHT,
	},
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		height: WALLET_HEIGHT,
		paddingLeft: 5,
		paddingRight: 9,
	},
	chipSlot: {
		width: CHIP.slotWidth,
		height: WALLET_HEIGHT,
	},
	chip: {
		position: 'absolute',
		left: 0,
		top: CHIP.top,
		width: CHIP.width,
		height: CHIP.height,
	},
	// Figma "Numeric/Balance": Sofia Sans Bold 16, letter-spacing -0.28, text/accent.
	balance: {
		flex: 1,
		textAlign: 'center',
		color: '#FFFF99',
		fontFamily: 'Sofia Sans',
		fontSize: 16,
		fontWeight: '700',
		letterSpacing: -0.28,
		lineHeight: 16,
	},
});

export default HeaderWallet;
